export const vehicleStatus: { [key: number]: string } = {
  1: 'active',
  2: 'inactive',
};
